const state = {
  users: [],
  selectedConsumer: null,
  selectedKioskConsumer: null,

};

const getters = {
  users: state => state.users,
  selectedConsumer: state => state.selectedConsumer,
  selectedKioskConsumer: state => state.selectedKioskConsumer,
};

const mutations = {
  SET_SELECTED_USER(state, payload) {
    state.selectedConsumer = payload;
  },
  SET_SELECTED_KIOSK_USER(state, payload) {
    state.selectedKioskConsumer = payload;
  },
  'CREDIT_PAYMENT' (state, amount) {
    const objIndex = state.users.findIndex((obj => obj.id === state.selectedConsumer.id));
    state.users[objIndex].balance = state.selectedConsumer.balance - amount;

    state.selectedConsumer = null;
  },
  ORDERED_PAYMENT(state, payload) {
    console.log('state, payload', state, payload);
  },
  VOUCHER_PAYMENT(state, payload) {
    console.log('state, payload', state, payload);
  },
};

const actions = {
  setSelectedConsumer({commit}, user) {
    commit('SET_SELECTED_USER', user);
  },
  setSelectedKioskConsumer({commit}, user) {
    commit('SET_SELECTED_KIOSK_USER', user);
  },
  creditPayment({commit}, amount) {
    commit('CREDIT_PAYMENT', amount);
  },
  preOrderedPayment({commit}, amount) {
    commit('ORDERED_PAYMENT', amount);
  },
  voucherPayment({commit}, amount) {
    commit('VOUCHER_PAYMENT', amount);
  },
};

export default {
  state,
  actions,
  getters,
  mutations
};
